const setSelectedFolderId = (state, payload) => {
  state.selections.selectedFolderId = payload
}

const setSelectedTab = (state, payload) => {
  state.selections.selectedTab = payload
}

const setSelectedSlideIds = (state, payload) => {
  state.selections.selectedSlideIds = payload
}

const setSelectedSortCriteria = (state, payload) => {
  state.selections.selectedSortCriteria = payload
}

export default {
  setSelectedTab,
  setSelectedFolderId,
  setSelectedSlideIds,
  setSelectedSortCriteria,
}
